import React, { useState,useEffect } from "react";
import { AutoComplete } from 'primereact/autocomplete';

 
const SeleccionConsecutivoServicioDenunciaA04 = (props) => {
  console.log(props);
  const [selectedAutoValue, setSelectedAutoValue] = useState(props.CONSECUTIVO_SERVICIO);
  const [autoFilteredValue, setAutoFilteredValue] = useState([]);
  const [autoValue, setAutoValue] = useState([]);
  const [reload, setReload] = useState(true)
  const APITABLASBASICAS = 'https://www.ancogenecop.com/APIANCO/controllers/selecciones.php?op='

  useEffect(() => {
    if(props.NID_PROPIETARIO==undefined || props.NID_PROPIETARIO==0 || props.codigo==0 || props.codigo==undefined) return;
    async function traerUsuarios(NID_PROPIETARIO,codigo) {
      const data = new FormData();
      data.append('NID_PROPIETARIO',NID_PROPIETARIO)
      data.append('CODIGO',codigo)
      await fetch(APITABLASBASICAS + 'seleccionConsecutivoServicioDenunciaA04', {
        method: 'POST',
        header: {
          'Accept': 'application/json',
          'Content-type': 'application/json'
        },
        body: data
      }).then((response) => response.json())
        .then((response) => {
            setReload(false)
            setAutoValue(response)
        })
        .catch((error) => {
          console.log(error);
        })
    }
        traerUsuarios(props.NID_PROPIETARIO,props.codigo)
  }, [reload,props.NID_PROPIETARIO,props.codigo]);


  const searchCountry = (event) => {
    setTimeout(() => {
        if (!event.query.trim().length) {
            setAutoFilteredValue([...autoValue]);
        }
        else {
            setAutoFilteredValue(autoValue.filter((a) => {
                return a.name.toUpperCase().startsWith(event.query.toUpperCase());
            }));
        }
    }, 250);
};



  const handleChange = (event) => {
    setSelectedAutoValue(event)
    if(event.code!=undefined){
      return props.handleplanta(event.code,11)
    }
    return props.handleplanta(event,11)
  };



  return (
    <div className="p-error">
      <AutoComplete placeholder="Buscar" id="dd" dropdown value={selectedAutoValue}
      onChange={(e) => handleChange(e.value)}
      suggestions={autoFilteredValue} completeMethod={searchCountry} field="name" />
    </div>
  );
};

export default SeleccionConsecutivoServicioDenunciaA04;
